/* 
  Core store module is all necessary functions required for running app and must be load first (No code splitting with dynamic import);
*/

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import { getField, updateField } from "vuex-map-fields";

export default {
  namespaced: true,
  getters: {
    getField,
    ...getters,
  },
  mutations: {
    updateField,
    ...mutations,
  },
  actions,
  state
};
